module.exports = __webpack_public_path__ + "img/alerts.ba82c9d7.svg";